(function () {
    // ===== CONFIG — sirf ethe change karo =====
    var RULES = [
        {
            options: ['bottom size', 'size'],
            labels: {
                'B-S': 'S',
                'B-M': 'M',
                'B-L': 'L',
                'B-XS': 'XS',
                'B-XL': 'XL'
            }
        },
        {
            options: ['top size'],
            labels: {
                'B-S': 'S',
                'B-M': 'M',
                'B-L': 'L',
                'B-XS': 'XS',
                'B-XL': 'XL'
            }
        }
        // ex: other options
        // ,{
        //     options: ['top size'],
        //     labels: { 'T-S': 'S', 'T-M': 'M', 'T-L': 'L' }
        // }
    ];
    // ===== CONFIG END =====

    var observer;
    var scheduled = false;

    function ruleFor(headText) {
        var text = (headText || '').toLowerCase();
        for (var i = 0; i < RULES.length; i++) {
            for (var j = 0; j < RULES[i].options.length; j++) {
                if (text.indexOf(RULES[i].options[j].toLowerCase()) !== -1) return RULES[i];
            }
        }
        return null;
    }

    function allLabels() {
        var merged = {};
        RULES.forEach(function (rule) {
            Object.keys(rule.labels).forEach(function (k) {
                merged[k] = rule.labels[k];
            });
        });
        return merged;
    }

    function setText(el, labels) {
        if (!el) return;
        var key = el.textContent.trim();
        if (labels[key] !== undefined && labels[key] !== key) el.textContent = labels[key];
    }

    function fixPicker() {
        document.querySelectorAll('.halo-productOptions [data-option-index]').forEach(function (box) {
            var head = box.querySelector('legend, .form__label, label.form__label');
            if (!head) return;

            var rule = ruleFor(head.textContent);
            if (!rule) return;

            setText(box.querySelector('[data-header-option]'), rule.labels);
            box.querySelectorAll('.product-form__label .text').forEach(function (el) { setText(el, rule.labels); });
            box.querySelectorAll('select option').forEach(function (el) { setText(el, rule.labels); });
        });
    }

    // cart title looks like "B-S / S / Gray"
    function fixCart() {
        var labels = allLabels();

        document.querySelectorAll('.cart-item-variant, .previewCartItem-variant, .product-edit-title-variant').forEach(function (el) {
            var current = el.textContent.trim();
            var next = current.split('/').map(function (part) {
                var key = part.trim();
                return labels[key] !== undefined ? labels[key] : key;
            }).join(' / ');

            if (next !== current) el.textContent = next;
        });
    }

    function run() {
        if (observer) observer.disconnect();
        fixPicker();
        fixCart();
        if (observer) observer.observe(document.documentElement, {
            childList: true,
            characterData: true,
            subtree: true
        });
    }

    // rAF runs before the browser paints, so nothing stale is ever shown
    function schedule() {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(function () {
            scheduled = false;
            run();
        });
    }

    observer = new MutationObserver(schedule);
    run();

    document.addEventListener('change', run, true);
    document.addEventListener('DOMContentLoaded', run);
})();